module.exports = __webpack_public_path__ + "static/media/paperclip-2.b1dd1777.svg";